import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import PopupDialogs from "component/MuiReusableComponents/MuiPopupDialog/new-popup";
import SalarySlipPopup from "component/EmployeeTabsViewDetails/TabsPanelComponent/salarySlipPopup";
import { Box, Paper, Typography, TableContainer, Collapse, Fab } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Outlet } from "react-router-dom";
import MyButton from "component/MuiReusableComponents/MuiButton/buttonMUI";
import { readStringDate } from "../../../../../function utils/functionUtils";
import EmployeeHeadBasic from "../../../../EmployesParentRoute/View Employee/reusable component/employeeBasicHead";
import { formatCurrency } from 'function utils/functionUtils';
import { useSelector } from "react-redux";
import { salarySlipLoadingSelector } from "store1/employees data/employeesData.slice.selector";

const EmployeeDataAndActiveCTC = ({
  activeCTCData,
  singleEmployeeAllCTCPayrolls,
  singleEmployeeOnlyBasic
}) => {

  const slipLoading = useSelector(salarySlipLoadingSelector);
  const [salarySlipPopup, setSalarySlipPopup] = useState(false);
  const { emp_id } = useParams();

  const monthNames = {
    "01": "January",
    "02": "February",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "August",
    "09": "September",
    "10": "October",
    "11": "November",
    "12": "December"
  };


  const salarySlipData = useSelector(s => s.EmployeesData.employeeSalaryData);
  const [openSlipTable, setOpenSlipTable] = useState(false);

  const downloadBase64PDF = (base64, fileName) => {
    if (!base64) return;

    try {
      const byteChar = atob(base64);
      const byteNum = new Array(byteChar.length);

      for (let i = 0; i < byteChar.length; i++) {
        byteNum[i] = byteChar.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNum);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "salary_slip.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  return (
    <>
      <Box>
        <Box sx={{
          bgcolor: "white",
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'start'
        }}>
          <EmployeeHeadBasic
            singleEmployeeData={singleEmployeeOnlyBasic}
          />
          <Box sx={{ p: 2 }}>
            <MyButton
              sx={{ ml: 2 }}
              variant="contained"
              size="small"
              onClick={() => {
                setSalarySlipPopup(true)
                setOpenSlipTable(true)
              }}
            >
              Get salary slip
            </MyButton>
          </Box>
        </Box>

        <PopupDialogs
          title="Salary Slip"
          size="sm"
          open={salarySlipPopup}
          setOpen={setSalarySlipPopup}
        >
          <SalarySlipPopup
            empId={parseInt(emp_id)}
            onClose={() => setSalarySlipPopup(false)}
          />
        </PopupDialogs>
      </Box>

      <Box sx={{ mt: 2 }}>
        {activeCTCData?.annual_ctc ? (
          <Paper>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow size="small">
                  <TableCell colSpan={4} size="small">
                    <Typography
                      gutterBottom
                      sx={{
                        fontWeight: 600,
                        marginRight: '110px',
                        flexGrow: "1",
                      }}
                      textAlign="center !important"
                    >
                      Current Salary Details
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow size="small">
                  <TableCell size="small" sx={{ width: "350px" }}>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520 }}
                    >
                      Annual CTC:
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520 }}
                    >
                      Basic Salary:
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520 }}
                    >
                      HRA :
                    </Typography>


                  </TableCell>
                  <TableCell size="small" sx={{ textAlign: 'right' }}>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520 }}
                    >
                      {formatCurrency(activeCTCData?.annual_ctc)}
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520 }}
                    >
                      {formatCurrency(Math.round(activeCTCData?.final_basic))}
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520 }}
                    >
                      {formatCurrency(activeCTCData?.hra)}
                    </Typography>

                  </TableCell>
                  <TableCell size="small">
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520, textAlign: "left" }}
                    >
                      Special Allowance :
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520, textAlign: "left" }}
                    >
                      Fixed Allowance:
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520, textAlign: "left" }}
                    >
                      Revision Date:
                    </Typography>
                  </TableCell>
                  <TableCell size="small">
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520, textAlign: "right" }}
                    >
                      {formatCurrency(activeCTCData?.special_allowance)}
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520, textAlign: "right" }}
                    >
                      {formatCurrency(activeCTCData?.fixed)}
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ fontWeight: 520, textAlign: "right" }}
                    >
                      {readStringDate(activeCTCData?.added_date)}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        ) : (
          <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
            <Typography sx={{ color: "error.main", textAlign: "center" }}>
              No CTC Defined !!
            </Typography>
          </Paper>
        )}
      </Box>

      {/* Salary Slips Table */}
      <Box sx={{ mt: 2 }}>
        <Paper
          sx={{
            display: "flex",
            margin: "15px 0px 5px 0px",
            padding: "15px 25px 15px 15px",
            alignItems: "center"
          }}
        >
          <Typography
            gutterBottom
            sx={{ fontWeight: 600, flexGrow: 1 }}
            textAlign="center !important"
          >
            Salary Slips
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Fab
              sx={{ marginLeft: "15px" }}
              color="primary"
              title="Expand/Collapse"
              aria-label="toggle"
              size="small"
              onClick={() => setOpenSlipTable(!openSlipTable)}
            >
              {openSlipTable ? "−" : "+"}
            </Fab>
          </Box>
        </Paper>

      </Box>

      <Collapse in={openSlipTable} timeout="auto" unmountOnExit>
        <Paper elevation={2} sx={{ bgcolor: 'white' }}>
          <TableContainer>
            <Table aria-label="salary slips table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell size="small" sx={{ fontWeight: 600 }}>Month</TableCell>
                  <TableCell size="small" sx={{ fontWeight: 600 }}>File Name</TableCell>
                  <TableCell size="small" sx={{ fontWeight: 600, textAlign: 'center' }}>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {slipLoading ? (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: "center", py: 4 }}>
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : salarySlipData?.files?.length > 0 ? (
                  salarySlipData.files.map((file, index) => (
                    <TableRow key={index}>
                      <TableCell>{monthNames[String(file.month).padStart(2, "0")]}</TableCell>
                      <TableCell>{file.fileName || "Unnamed File"}</TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        <MyButton
                          variant="outlined"
                          size="small"
                          onClick={() =>
                            downloadBase64PDF(file.base64, file.fileName)
                          }
                        >
                          Download
                        </MyButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: 'center', py: 3 }}>
                      <Typography color="text.secondary">
                        No salary slips available.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Collapse>


      <Outlet />
    </>
  );
};

export default EmployeeDataAndActiveCTC;